module.exports = __webpack_public_path__ + "img/wechat-enterprise.736827bc.svg";